export default "__VITE_ASSET__zJJMxyYM__"